module.exports = __webpack_public_path__ + "img/02_full.603baa28.jpg";